import { STORY_EDITION, STORY_BY_ID } from '@hyakki/core/data/stories';
import { storyCuesForBattle, type StoryCue } from '@hyakki/core/data/story-moments';
import { COUNTRIES, PROVINCE_BY_ID, conqueredCount, countryStages, isCountryConquered } from '@hyakki/core/meta/provinces';
import { state } from '../state';
import { go } from '../router';
import { readLocal, writeLocal } from './storage';

const memory = new Set<string>();
function key() { return `hk.story.seen.${STORY_EDITION}.${state.me?.user.id ?? 'guest'}`; }
export function markCueSeen(cue: StoryCue) {
  const k = key();
  const saved = readLocal<unknown>(k, []);
  const ids = new Set(Array.isArray(saved) ? saved.filter(x => typeof x === 'string') : []);
  ids.add(cue.id); memory.add(`${k}:${cue.id}`); writeLocal(k, [...ids]);
}
export function pendingCue(stage: number, timing: 'before' | 'after') {
  if (!state.me) return;
  const saved = readLocal<unknown>(key(), []);
  const seen = new Set(Array.isArray(saved) ? saved : []);
  return storyCuesForBattle(state.me.profile, stage, timing).find(cue => !seen.has(cue.id) && !memory.has(`${key()}:${cue.id}`));
}
export function playCue(cue: StoryCue, destination: 'battle' | 'result', params: Record<string, string | number> = {}) {
  go('story', { ...params, id: cue.episodeId, at: STORY_BY_ID[cue.episodeId].lines[cue.start].id, cue: cue.id, back: destination }, true);
}

/**
 * 読んだ場面（物語で読み返せる場面）：この端末で再生したものと、進み具合（クリアした戦・制圧した国）からもう流れたはずのもの。
 * 進み具合からも割り出すので、別の端末・ブラウザでも読み返せる
 */
export function readCueIds(): Set<string> {
  const ids = new Set<string>();
  const saved = readLocal<unknown>(key(), []);
  if (Array.isArray(saved)) for (const x of saved) if (typeof x === 'string') ids.add(x);
  const p = state.me?.profile;
  if (!p) return ids;
  const cleared = (id: number) => (p.progress[String(id)]?.clears ?? 0) > 0;
  if (cleared(1)) ids.add('main-00:intro').add('main-00:aftermath');
  for (const c of COUNTRIES) {
    const ep = `main-${String(c.difficulty).padStart(2, '0')}`;
    // 入国：その国の戦を1つ取った（青葉国は里の初戦＝1面のほかに）
    if (countryStages(c).some((id) => (c.id !== 'c01' || id !== 1) && cleared(id))) ids.add(`${ep}:enter`);
    if (cleared(PROVINCE_BY_ID[c.regions[0]].castle)) ids.add(`${ep}:fort`);
    if (cleared(PROVINCE_BY_ID[c.regions[1]].castle)) ids.add(`${ep}:castle`);
    if (isCountryConquered(p, c.id)) ids.add(`${ep}:clear`);
  }
  if (conqueredCount(p) === COUNTRIES.length) ids.add('main-11:ending');
  return ids;
}